import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PrintWizard } from '../components/printing/PrintWizard';

export function Printing() {
  const navigate = useNavigate();

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} size="small">
          Back
        </Button>
        <Typography variant="h4" component="h1" fontWeight={600}>
          Print Asset Labels
        </Typography>
      </Box>

      <PrintWizard onClose={() => navigate('/assets')} />
    </Box>
  );
}
